import { connect } from 'react-redux'
import { compose } from 'recompose'

import { makesMutations } from 'data/graphql'
import { dataFetched } from 'data/graphql/reducer'
import { setActiveModal } from 'data/ui/actions'
import { createNoteMutation } from 'remote/notes'
import { PAYMENT_INCENTIVE } from 'components/Utils/Modal/constants'

const QUOTA_ERROR_ID = 'note-creation/over-quota'

export const provideCreateNote = compose(
  connect(
    null,
    {
      dataFetched,
      setActiveModal,
    }
  ),
  makesMutations({
    query: createNoteMutation,
    mutationPropName: 'createNote',
    defaultVariables: {
      title: '',
      snapshot: [{ insert: '\n' }],
    },
    getOnResultFromProps: ({ dataFetched }) => ({ result, meta }) => {
      const note = result.data.createNote
      dataFetched(note)
    },
    getOnErrorFromProps: ({ setActiveModal }) => ({ error }) => {
      if (
        error.errors &&
        error.errors.length > 0 &&
        error.errors[0].id === QUOTA_ERROR_ID
      ) {
        setActiveModal({ id: PAYMENT_INCENTIVE })
      }
    },
  })
)
